<span
  *ngxPermissionsOnly="[
    role.pricingManager,
    role.organizationAdmin,
    role.customerService,
  ]"
>
  @if (hasCompanies && !(hideWhenEmpty() && companyList.length === 0)) {
    <p-select
      [options]="companyList"
      [multiple]="true"
      [filter]="true"
      filterBy="label"
      [disabled]="disabled()"
      [ngModel]="companies"
      (ngModelChange)="companies = $event; onCompanyChange($event)"
      appendTo="body"
      panelStyleClass="p-select-checkbox-options"
      placeholder="All Companies"
      [lazy]="true"
      dataKey="id"
    >
      <ng-template #item let-option>
        <p-checkbox
          [ngModel]="isSelected(option.value)"
          [binary]="true"
          [readonly]="true"
          [tabindex]="-1"
        />
        <span>{{ option.label }}</span>
      </ng-template>

      <ng-template #selectedItem>
        <app-selected-chips
          [items]="companies"
          [label]="chipLabel"
          [key]="chipKey"
          [removable]="!disabled()"
          (removeItem)="removeCompany($event)"
        />
      </ng-template>
    </p-select>
  }
</span>
